import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders,APIURL,JsonURL } from '../common/headers';
import { IUsers } from '../database';
@Injectable()
export class LoginService {
    private _CountryUrl = JsonURL+'data/countries.json';
    private _StateUrl = JsonURL+'data/countries/';
    private _loginUrl = APIURL+'Users/login';
    private _forgetPasswordUrl = APIURL+'Users/forgetPassword';
    private _checkEmailUrl = APIURL+'Users/validEmail';
     private currentUser :IUsers ; 
    constructor(private _http: Http) { 
           
    }
    setCurrentUser(user:IUsers){
        this.currentUser=user
    }
    getCurrentUser(){
       return this.currentUser; 
    }
    getCountry(): any  {
        return this._http.post(this._CountryUrl,[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getStateByCountry(con:string): any  {
        return this._http.post(this._StateUrl+con+".json",[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    login(form:any): any  {

         let formData:FormData = new FormData();
         formData.append('username', form.username);
         formData.append('password', form.password);
        return this._http.post(this._loginUrl,formData)
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    forgetPassword(form:any): any  {
                 let formData:FormData = new FormData();
                 formData.append('username', form.username);
                return this._http.post(this._forgetPasswordUrl,formData)
                    .map((response: Response) => response.json())
                    .catch(this.handleError);
            }
     private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/login.service.ts